import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wait-list',
  templateUrl: './wait-list.component.html',
  styleUrls: ['./wait-list.component.scss']
})
export class WaitListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
